<!-- A popup dialog to select a different brand -->
<app-choose-brand [displayBrandDialog] = "openBrandSelectionDialog" (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>

<!--- Generic header, inclusing current brand andd a button to select another brand -->

<div class="grid">
    <div class="col-6">
        <app-brand-admin-header></app-brand-admin-header>
    </div>
    <div class="col-1">
        <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"  
             class="p-button-raised p-button-rounded" >
         </button>
    </div>  
    <app-side-menu  [parentForm] = "currentForm"></app-side-menu>
</div> 


<!-- Dropdowns for selecting Pass Tempalte and Offer -->
<!-- 
<div class="grid col-8">

    <p-card header="Settings Criteria" subheader="" class="ui-card-light" >

        <div class="grid">

        <div class="col-3">
            <label for="passTemplate" class="margin-left">Pass Template: </label>
            <p-select id ="passTemplate" [options]="passTemplates" [(ngModel)]="selectedPassTemplate" (onChange)="onChangePassTemplate($event)"
                [filter]="false" [editable]="false" [style]="{'width': '100%'}">
            </p-select>
        </div> 

        <div class="col-3">
            <label for="offer" class="margin-left">Field Set: </label>
            <p-select id ="offer" [options]="offers" [(ngModel)]="selectedOffer" (onChange)="onChangeOffer($event)"
                [filter]="false" [editable]="false" [style]="{'width': '100%'}">
            </p-select>
        </div> 

        <div class="col-4">
            <label for="sourceChannel" class="margin-left">Source Channel: </label>
            <p-select id ="sourceChannel" [options]="sourceChannels" [(ngModel)]="selectedChannel" (onChange)="onChangeChannel($event)"
                [filter]="false" [editable]="false" [style]="{'width': '100%'}">
            </p-select>
        </div> 

        <div class="col-2" id="idSpinner" [hidden]="isSpinnerHidden">
            <div class="loader"></div>  
        </div>

    </div>

        <p-footer>
            <mat-icon class="nav-caption wal-center">settings</mat-icon>
        </p-footer>



    </p-card>

</div> 
 -->



<!-- Outer grid to center the card -->
<div class="grid ">
  <!-- Full width on small screens, half on md+ -->
  <div class="col-12 md:col-6">
    <p-card header="Settings Criteria" subheader="" class="ui-card-light" [style]="{ width: '100%' }">

      <div class="grid">
        <div class="col-12 md:col-4">
          <label for="passTemplate" class="margin-left">Pass Template: </label>
          <p-select
            id="passTemplate"
            [options]="passTemplates"
            [(ngModel)]="selectedPassTemplate"
            (onChange)="onChangePassTemplate($event)"
            [filter]="false"
            [editable]="false"
            [style]="{ width: '100%' }">
          </p-select>
        </div>

        <div class="col-12 md:col-3">
          <label for="offer" class="margin-left">Field Set: </label>
          <p-select
            id="offer"
            [options]="offers"
            [(ngModel)]="selectedOffer"
            (onChange)="onChangeOffer($event)"
            [filter]="false"
            [editable]="false"
            [style]="{ width: '100%' }">
          </p-select>
        </div>

        <div class="col-12 md:col-3">
          <label for="sourceChannel" class="margin-left">Source Channel: </label>
          <p-select
            id="sourceChannel"
            [options]="sourceChannels"
            [(ngModel)]="selectedChannel"
            (onChange)="onChangeChannel($event)"
            [filter]="false"
            [editable]="false"
            [style]="{ width: '100%' }">
          </p-select>
        </div>

        <div class="col-12 md:col-2" id="idSpinner" [hidden]="isSpinnerHidden">
          <div class="loader"></div>
        </div>
      </div>

      <p-footer>
        <mat-icon class="nav-caption wal-center">settings</mat-icon>
      </p-footer>

    </p-card>
  </div>
</div>


<!-- Dynamic list of enrollment links for the brand -->
@for (enrollmentLink of enrollmentLinks; track enrollmentLink) {
  <div class="form-row">
    <app-enrollment
      [enrollmentLinkAttribute]="enrollmentLink">
    </app-enrollment>
  </div>
}



<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="enrollment-links"></p-confirmDialog>

